import React from 'react';
import {ProgressBar} from 'react-bootstrap';

export default function Progress(props){

// console.log(props)
if (props.visible == true)
{
return(

    // <ProgressBar striped now={props.progress}/>
<div style={{border: '1px solid slateblue', borderRadius:'15px', marginTop:30, marginLeft:500, marginRight: 500, textAlign:'center', background: '#dccca9'}} >
    <label style={{fontSize: 20}} >{props.title}</label>
    <br/>
    <progress style={{height:40}} id="progress" max="100" value={props.progress}> {props.progress}% </progress>
</div>
)
}

return (
    <div/>
)

}